import { render, staticRenderFns } from "./LeadProvider.vue?vue&type=template&id=8f1b4a68"
import script from "./LeadProvider.vue?vue&type=script&lang=js"
export * from "./LeadProvider.vue?vue&type=script&lang=js"
import style0 from "./LeadProvider.vue?vue&type=style&index=0&id=8f1b4a68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports